const baseTemplate = {
  email: 'String',
  account_balance: 'Number',
  coupon: 'String',
  default_source: 'String',
  description: 'String',
  metadata: {
    key: 'value',
  },
}

export default baseTemplate
